import React from "react";
import { SpinnerContainer, SpinnerOverlay } from "./Spinner.style";

export default function Spinner() {
  return (
    <SpinnerOverlay>
      <SpinnerContainer />
    </SpinnerOverlay>
  );
}

// export const WithSpinner = WrappedComponent => {
//   const Spinner = ({isLoading, ...otherProps}) => {
//     return isLoading ? (
//       <SpinnerOverlay>
//         <SpinnerContainer />
//       </SpinnerOverlay>
//     ): (
//       <wrappedComponent {...otherProps} />
//     );
//   };
//   return Spinner;
// };
